import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "../../lib/api";
import { CalendarCheck, UserPlus, GraduationCap, EnvelopeSimple } from "@phosphor-icons/react";

export function WeeklyDigest() {
  const { data } = useQuery({
    queryKey: ["weekly-digest"],
    queryFn: () => api.post("/digest/weekly-check").then((r) => {
      if (r.data.generated) toast.info("Monday partner digest generated & emailed to partners");
      return r.data.digest;
    }),
    staleTime: 5 * 60 * 1000,
  });
  if (!data?.week) return null;
  const s = data.stats || {};
  return (
    <div className="rounded-lg border border-zinc-200 bg-white p-5" data-testid="weekly-digest">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-medium text-zinc-900 flex items-center gap-1.5"><EnvelopeSimple size={15} /> Monday Partner Digest — week of {data.week_of}</h3>
        <span className="text-[10px] text-zinc-400 font-mono">{s.active_returns} active · {s.in_review} in review · ${(s.unpaid_ar || 0).toLocaleString()} AR</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div data-testid="digest-deadlines">
          <p className="text-[10px] uppercase tracking-wide text-zinc-400 mb-1.5 flex items-center gap-1"><CalendarCheck size={12} /> Deadlines (14d)</p>
          {(data.deadlines || []).slice(0, 5).map((d, i) => (
            <p key={i} className="text-[11px] text-zinc-700 py-0.5">{d.client_name} — {d.service_type} <span className={`font-mono ${d.days_left <= 3 ? "text-rose-600" : "text-amber-600"}`}>{d.days_left}d</span></p>
          ))}
          {!data.deadlines?.length && <p className="text-[11px] text-zinc-400 italic">Nothing due in 14 days</p>}
        </div>
        <div data-testid="digest-leads">
          <p className="text-[10px] uppercase tracking-wide text-zinc-400 mb-1.5 flex items-center gap-1"><UserPlus size={12} /> New leads (7d)</p>
          {(data.new_leads || []).slice(0, 5).map((l, i) => (
            <p key={i} className="text-[11px] text-zinc-700 py-0.5">{l.name} <span className="text-zinc-400">via {l.referrer || "website"}</span></p>
          ))}
          {!data.new_leads?.length && <p className="text-[11px] text-zinc-400 italic">No new leads this week</p>}
        </div>
        <div data-testid="digest-coaching">
          <p className="text-[10px] uppercase tracking-wide text-zinc-400 mb-1.5 flex items-center gap-1"><GraduationCap size={12} /> Coaching insights (30d)</p>
          {(data.coaching?.top_mistakes || []).map((m, i) => (
            <p key={i} className="text-[11px] text-zinc-700 py-0.5">{m.label} <span className="font-mono text-rose-600">×{m.count}</span></p>
          ))}
          {data.coaching?.most_coached && <p className="text-[10px] text-zinc-400 mt-1">Most coached: {data.coaching.most_coached}</p>}
          {!data.coaching?.top_mistakes?.length && <p className="text-[11px] text-zinc-400 italic">No repeated corrections</p>}
        </div>
      </div>
      {data.training_focus && <p className="text-[11px] text-zinc-600 mt-3 border-t border-zinc-100 pt-2"><span className="font-medium">Training focus:</span> {data.training_focus}</p>}
    </div>
  );
}
